import React, { useState } from 'react';
import { Search, CheckCircle2, XCircle, MessageCircle, Loader2 } from 'lucide-react';
import { API_URL } from '../config/api';

const WHATSAPP_NUMBER = '19548059212';

const RedimirPage = () => {
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [cert, setCert] = useState(null);

  const handleValidar = async (e) => {
    e.preventDefault();
    setError('');
    setCert(null);
    if (!codigo.trim()) {
      setError('Ingresa tu codigo de certificado.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/certificados/validar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigo: codigo.trim() })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || 'Certificado no encontrado.');
        return;
      }
      setCert(data);
    } catch {
      setError('Error de conexion. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const whatsappMsg = cert
    ? `Hola, quiero activar mi certificado de $500 USD.%0A%0AMi codigo es: ${cert.codigo}%0ANombre: ${cert.nombre}%0AEmail: ${cert.email}%0ASaldo disponible: $${cert.saldo} USD`
    : '';

  return (
    <div className="min-h-screen" style={{ background: '#1A1A2E', fontFamily: "'DM Sans', sans-serif" }}>
      {/* Header */}
      <header className="border-b-2 border-[#B8860B] py-8 text-center" style={{ background: 'linear-gradient(180deg, #0d0d1e 0%, #1A1A2E 100%)' }}>
        <p className="text-[11px] tracking-[3px] text-[#D4AF37] mb-2" style={{ fontFamily: 'monospace' }}>Activacion de Certificado</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-wide" style={{ color: '#FDFAF3' }}>
          CLUB <span className="text-[#D4AF37]">VIAJEMOS</span>
        </h1>
        <p className="text-xs tracking-[2px] text-[#888] mt-2">R E D I M I R &nbsp; C E R T I F I C A D O &nbsp; D E &nbsp; V I A J E</p>
      </header>

      <main className="flex justify-center px-6 py-16">
        <div className="w-full max-w-lg">

          {!cert ? (
            <>
              {/* Search Form */}
              <div className="text-center mb-10">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{ background: 'rgba(212,175,55,0.15)', border: '2px solid rgba(212,175,55,0.3)' }}>
                  <Search className="h-7 w-7 text-[#D4AF37]" />
                </div>
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#FDFAF3' }}>Consulta tu Certificado</h2>
                <p className="text-sm" style={{ color: 'rgba(253,250,243,0.5)' }}>
                  Ingresa el codigo unico de tu certificado para verificar tu saldo y activarlo
                </p>
              </div>

              <form onSubmit={handleValidar} className="border p-8" style={{ background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(212,175,55,0.25)' }} data-testid="redimir-form">
                {error && (
                  <div className="mb-5 p-3 text-sm border-l-[3px] border-red-600 flex items-center gap-2" style={{ background: 'rgba(192,57,43,0.15)', color: '#e88' }}>
                    <XCircle className="h-4 w-4 flex-shrink-0" /> {error}
                  </div>
                )}
                <label className="block text-[11px] tracking-wider uppercase text-[#888] mb-2" style={{ fontFamily: 'monospace' }}>
                  Codigo del certificado
                </label>
                <input
                  type="text"
                  value={codigo}
                  onChange={e => setCodigo(e.target.value.toUpperCase())}
                  placeholder="Ej: CV-HTL-2026-00001-ABC123"
                  data-testid="redimir-codigo"
                  className="w-full px-4 py-3 text-sm font-mono outline-none mb-4 tracking-wider"
                  style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', color: '#D4AF37', letterSpacing: '1px' }}
                  onFocus={e => e.target.style.borderColor = '#D4AF37'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="redimir-submit"
                  className="w-full py-4 text-lg font-bold tracking-[3px] cursor-pointer transition-colors disabled:opacity-50"
                  style={{ background: '#D4AF37', color: '#1A1A2E', border: 'none' }}
                  onMouseEnter={e => !loading && (e.target.style.background = '#B8860B')}
                  onMouseLeave={e => (e.target.style.background = '#D4AF37')}
                >
                  {loading ? <><Loader2 className="inline h-5 w-5 animate-spin mr-2" />VERIFICANDO...</> : 'VERIFICAR CERTIFICADO'}
                </button>
              </form>
            </>
          ) : (
            <>
              {/* Certificate Found */}
              <div className="border" style={{ background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(212,175,55,0.25)' }}>
                <div className="text-center py-6 px-8 border-b" style={{ background: 'rgba(30,132,73,0.12)', borderColor: 'rgba(30,132,73,0.3)' }}>
                  <CheckCircle2 className="h-10 w-10 mx-auto mb-2" style={{ color: '#6de89a' }} />
                  <h3 className="text-xl font-bold tracking-wider" style={{ color: '#6de89a' }}>CERTIFICADO VERIFICADO</h3>
                  <p className="text-sm text-[#888] mt-1">Tu certificado es valido y esta activo</p>
                </div>

                <div className="px-8 py-6" data-testid="redimir-result">
                  {[
                    { key: 'Beneficiario', val: cert.nombre },
                    { key: 'Codigo', val: cert.codigo, isMono: true },
                    { key: 'Saldo disponible', val: `USD $${cert.saldo.toFixed(2)}`, isGreen: true },
                    { key: 'Estado', val: cert.estado === 'activo' ? 'ACTIVO' : cert.estado.toUpperCase(), isGreen: cert.estado === 'activo' },
                    { key: 'Emision', val: cert.emision },
                    { key: 'Vencimiento', val: cert.vencimiento, isRed: true },
                    ...(cert.agente_nombre ? [{ key: 'Agente referidor', val: cert.agente_nombre }] : []),
                  ].map((row) => (
                    <div key={row.key} className="flex justify-between items-center py-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                      <span className="text-[11px] tracking-wide text-[#888]" style={{ fontFamily: 'monospace' }}>{row.key}</span>
                      <span className={`text-sm font-medium ${row.isMono ? 'font-mono text-[#D4AF37] text-xs' : ''}`}
                        style={{ color: row.isGreen ? '#6de89a' : row.isRed ? '#e88' : '#FDFAF3' }}
                      >
                        {row.val}
                      </span>
                    </div>
                  ))}
                </div>

                {/* WhatsApp CTA */}
                <div className="px-8 pb-8">
                  <div className="p-5 text-center mb-4" style={{ background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.25)' }}>
                    <p className="text-sm mb-1" style={{ color: '#FDFAF3' }}>Para activar tu certificado y reservar tu hotel:</p>
                    <p className="text-xs" style={{ color: 'rgba(253,250,243,0.5)' }}>Contacta a nuestro equipo por WhatsApp y te asistimos en todo el proceso</p>
                  </div>

                  <a
                    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMsg}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="redimir-whatsapp"
                    className="flex items-center justify-center gap-3 w-full py-4 text-lg font-bold tracking-wider no-underline transition-colors"
                    style={{ background: '#25D366', color: '#fff', border: 'none' }}
                    onMouseEnter={e => (e.target.style.background = '#1da851')}
                    onMouseLeave={e => (e.target.style.background = '#25D366')}
                  >
                    <MessageCircle className="h-6 w-6" />
                    ACTIVAR POR WHATSAPP
                  </a>
                </div>

                <div
                  onClick={() => { setCert(null); setCodigo(''); setError(''); }}
                  className="text-center py-4 text-sm tracking-wide text-[#888] cursor-pointer border-t hover:text-[#FDFAF3] transition-colors"
                  style={{ borderColor: 'rgba(212,175,55,0.25)' }}
                  data-testid="redimir-new"
                >
                  Consultar otro certificado
                </div>
              </div>
            </>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-xs border-t" style={{ background: '#0d0d1e', borderColor: 'rgba(212,175,55,0.25)', color: '#888' }}>
        <p>&copy; 2025 Club Viajemos / Travel Empire — <a href="https://www.clubviajemos.com" className="text-[#D4AF37] no-underline">www.clubviajemos.com</a></p>
      </footer>
    </div>
  );
};

export default RedimirPage;
